import BreadCrumb from "../screens/Common/BreadCrumb";

import React from "react";
import LayoutContainer from "../screens/layout/admin-dashboard";
import AutoNumberingList from "../screens/masters/autoNumbering/autoNumberingList";

const breadCrumbData = [
  { link: "/masters-list", name: "Masters" },
  { link: "/auto-numbering-list", name: "Auto Numbering" }
];

const Home = () => (
  <>
    <LayoutContainer>
      <BreadCrumb data={breadCrumbData} />
      <AutoNumberingList />
    </LayoutContainer>
  </>
);

export default Home;
